import { Eta } from '@app/components/various/Icons';
import React from 'react';

interface Props {
  color: string;
  label: string;
  isHoverable?: boolean;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
}

export const EtaLegendItem = ({ color, label, isHoverable = false, onMouseEnter, onMouseLeave }: Props) => {
  const hoverableAttributes = {
    onMouseEnter,
    onMouseLeave,
  };

  return (
    <div className="flex items-center gap-1 body-5" {...(isHoverable && hoverableAttributes)}>
      <span className="relative" style={{ color }}>
        <Eta size={5} />
        <div className="absolute top-0 h-full w-full rounded-small bg-current opacity-15" />
      </span>
      {label}
    </div>
  );
};
